/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    TextField,
    Toolbar,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import React from 'react';
import { IFormularioTiposMovimientosVistaProps } from '../interfaces';
const FormularioTiposMovimientosVista: React.FunctionComponent<IFormularioTiposMovimientosVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    tiposMovimientos,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'tiposMovimientos.agregarTiposMovimientos'
                                : 'tiposMovimientos.modificarTiposMovimientos'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="tiposMovimientos.tipoMovimientoDescripcion" display="inline" />}
                        name="TipoMovimientoDescripcion"
                        onChange={cambiarInfoFomulario}
                        required
                        id={`CampotipoMovimientoDescripcion-${tiposMovimientos.TipoMovimientoDescripcion}`}
                        value={tiposMovimientos.TipoMovimientoDescripcion}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={Number(tiposMovimientos.Estado) === 1 ? true : false}
                                onChange={cambiarInfoFomulario}
                            />
                        }
                        label={<Texto id="productos.estado" display="inline" />}
                        id={`Estado`}
                        name="Estado"
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Grid container justifyContent="flex-end" spacing={2}>
                <Grid item>
                    <Button onClick={cerrarFormulario} color="secondary" variant="contained" id="boton-cancelar">
                        <Texto id="boton.cancelar" />
                    </Button>
                </Grid>
                <Grid item>
                    <Button onClick={accionCrearEditar} color="primary" variant="contained" id="boton-editar">
                        <Texto id="boton.guardar" />
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
    </Dialog>
);

export default FormularioTiposMovimientosVista;
